import React from 'react';

const WinnerModal = ({ 
  show, 
  winners = [], 
  currentPlayer = '', 
  finalScore = 0,
  onGetRewarded, 
  onPlayAgain, 
  onBackToLobby, 
  onClose 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm overflow-y-auto p-2 sm:p-4">
      <div className="relative w-full max-w-sm sm:max-w-lg md:max-w-md bg-black/60 backdrop-blur-md rounded-xl sm:rounded-2xl md:rounded-3xl shadow-2xl border border-white/20 overflow-hidden max-h-[95vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-3 sm:p-4 border-b border-white/20">
          <h2 className="text-lg sm:text-xl uppercase text-white">🏆 Victory!</h2>
          <button 
            className="p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-all duration-200"
            onClick={onClose}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="p-3 sm:p-4 ">
          <div className="text-center">
            {/* Winner Animation */}
            <div className="mb-4 sm:mb-6 md:mb-8">
              <div className="inline-flex items-center justify-center w-12 h-12  mb-3 sm:mb-4 md:mb-6 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full shadow-2xl">
                <svg className="w-8 h-8  text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 mb-2 sm:mb-3 md:mb-4">
                You Win! 🎉
              </h3>
              <p className="text-sm sm:text-base  text-white/90 mb-4 sm:mb-6 md:mb-8 px-2">
                Congratulations! You defeated all other players and emerged victorious!
              </p>
            </div>

            {/* Winner Details */}
            <div className="bg-gradient-to-r from-yellow-400/20 to-orange-500/20 backdrop-blur-sm rounded-lg sm:rounded-xl md:rounded-2xl p-3 sm:p-4  mb-4 sm:mb-6 md:mb-8 border border-yellow-400/30">
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                  <span className="text-xl sm:text-2xl md:text-3xl">🏆</span>
                  <div>
                    <span className="text-white/70 text-xs sm:text-sm block">Champion</span>
                    <p className="text-white font-bold text-base sm:text-lg">{currentPlayer}</p>
                  </div>
                </div>
                
                <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                  <span className="text-xl sm:text-2xl md:text-3xl">⭐</span>
                  <div>
                    <span className="text-white/70 text-xs sm:text-sm block">Final Score</span>
                    <p className="text-white font-bold text-base sm:text-lg">{finalScore} points</p>
                  </div>
                </div>

                {winners.length > 1 && (
                  <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-white/20">
                    <span className="text-white/70 text-xs sm:text-sm block mb-1 sm:mb-2">All Winners:</span>
                    <p className="text-white font-semibold text-sm sm:text-base md:text-lg">{winners.join(', ')}</p>
                  </div>
                )}
              </div>
            </div>

            {/* Victory Badge */}
            <div className="flex justify-center mb-4 sm:mb-6 md:mb-8">
              <span className="inline-flex items-center px-3 sm:px-4 md:px-6 lg:px-8 py-2 sm:py-3 md:py-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold text-sm  rounded-full shadow-lg">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 mr-1 sm:mr-2 md:mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
                CHAMPION! 🏆
              </span>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-2 sm:gap-3 md:gap-4">
            <a 
              href="/dashboard"
              onClick={onGetRewarded}
              className="flex col-span-2 items-center justify-center space-x-2 sm:space-x-3 px-3 sm:px-4 md:px-6 py-3  bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold text-sm rounded-lg md:rounded-xl shadow-lg hover:shadow-xl active:scale-95 transition-all duration-200 no-underline"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <span>Get Rewarded</span>
            </a>
            
            <a 
              href="/game-lobby/lobby"
              onClick={onPlayAgain}
              className="flex items-center justify-center space-x-2 sm:space-x-3 px-3 sm:px-4 md:px-6 py-3 bg-gradient-to-r from-cyan-400 to-blue-500 text-white font-bold text-sm rounded-lg md:rounded-xl shadow-lg hover:shadow-xl active:scale-95 transition-all duration-200 no-underline"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              <span>Play Again</span>
            </a>
            
            <a 
              href="/game-lobby/lobby"
              onClick={onBackToLobby}
              className="flex items-center justify-center space-x-2 sm:space-x-3 px-3 sm:px-4 md:px-6 py-3  bg-white/20 backdrop-blur-sm text-white font-bold text-sm rounded-lg md:rounded-xl border border-white/30 hover:bg-white/30 active:scale-95 transition-all duration-200 no-underline"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Back to Lobby</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinnerModal;
